import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Pill from "../../../atoms/CardPill";
import {
  getAMPVerdict,
  getCardsIsCompact,
} from "../../../../state/selectors/CardsUI.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { getAMPThrottling } from "../../../../state/selectors/AMPComponent.selectors";
import {
  getIsUserPremiumOrClinical,
  hasAMPClassificationErrors,
} from "../../../../state/selectors/general.selectors";

const AmpCard = ({
  card,
  ampVerdict,
  isCompact,
  ampThrottlingInfo,
  hasAMPErrors,
  isUserPremiumOrClinical,
}) => {
  const isDisabled =
    !Object.keys(ampVerdict || {}).length && !ampThrottlingInfo;
  const pathoColor = getPathogenicityColorByAllNames("pathogenic");

  const color = getPathogenicityColorByAllNames(ampVerdict?.tier) || card.color;
  const secondaryTitle = isCompact && ampVerdict?.tier && !hasAMPErrors && (
    <b style={{ color }}>{ampVerdict?.tier}</b>
  );
  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={hasAMPErrors ? pathoColor : color}
      secondaryTitle={secondaryTitle}
    >
      {ampVerdict &&
        ampVerdict.tier &&
        !hasAMPErrors &&
        isUserPremiumOrClinical && (
          <div data-testid="amp-card-content">
            <Pill inverted={false} verdict={ampVerdict?.tier} />
          </div>
        )}
      {hasAMPErrors && (
        <div>
          <Pill inverted={false} verdict="Error" backgroundColor={pathoColor} />
        </div>
      )}
    </CardWrapper>
  );
};

AmpCard.propTypes = {
  ampVerdict: PropTypes.shape({
    tier: PropTypes.string,
  }),
  hasAMPErrors: PropTypes.bool,
  card: PropTypes.instanceOf(Card).isRequired,
  isCompact: PropTypes.bool.isRequired,
  ampThrottlingInfo: PropTypes.shape({
    throttling_msg: PropTypes.string,
  }),
  isUserPremiumOrClinical: PropTypes.bool.isRequired,
};

AmpCard.defaultProps = {
  ampVerdict: null,
  hasAMPErrors: false,
  ampThrottlingInfo: null,
};

const mapStateToProps = (state) => ({
  ampVerdict: getAMPVerdict(state),
  isCompact: getCardsIsCompact(state),
  ampThrottlingInfo: getAMPThrottling(state),
  hasAMPErrors: hasAMPClassificationErrors(state),
  isUserPremiumOrClinical: getIsUserPremiumOrClinical(state),
});

export default connect(mapStateToProps)(AmpCard);
